"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PIMTokenService = _interopRequireDefault(require("../services/PIMTokenService"));

var _DeviceContentService = _interopRequireDefault(require("../services/compatibility-guide/DeviceContentService"));

var _ProductContentService = _interopRequireDefault(require("../services/compatibility-guide/ProductContentService"));

var _AppContentService = _interopRequireDefault(require("../services/compatibility-guide/AppContentService"));

var _AccessoryContentService = _interopRequireDefault(require("../services/compatibility-guide/AccessoryContentService"));

var _ResourceContentService = _interopRequireDefault(require("../services/resource-center/ResourceContentService"));

var _FilterContentService = _interopRequireDefault(require("../services/resource-center/FilterContentService"));

var _BrowseAccessoriesService = _interopRequireDefault(require("../services/pep/BrowseAccessoriesService"));

var _BrowseHearingAidsService = _interopRequireDefault(require("../services/pep/BrowseHearingAidsService"));

var _ProductDetailsService = _interopRequireDefault(require("../services/pep/ProductDetailsService"));

var _RelatedAccessoriesService = _interopRequireDefault(require("../services/pep/RelatedAccessoriesService"));

var _GeneralService = _interopRequireDefault(require("../services/pep/GeneralService"));

var _serviceNames = require("../constants/service-names");

var _serviceEndpoints = _interopRequireDefault(require("../constants/service-endpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class
 */
var PIM =
/*#__PURE__*/
function () {
  function PIM() {
    _classCallCheck(this, PIM);

    this.isPhoneArenaQuery = this.checkIsPhoneArenaQuery();
    this.isPEPGateway = false;
  }

  _createClass(PIM, [{
    key: "checkIsPhoneArenaQuery",
    value: function checkIsPhoneArenaQuery() {
      return globalThis.window ? globalThis.window.location.href.includes('phonearena') : false;
    }
    /**
     *
     * @param {string} value
     */

  }, {
    key: "setLanguageCode",
    value: function setLanguageCode(value) {
      this.languageCode = value;
    }
    /**
     * @returns {string}
     */

  }, {
    key: "getCachedCatalogId",
    value: function getCachedCatalogId() {
      return this.cachedCatalogId ? this.cachedCatalogId : null;
    }
    /**
     *
     * @param {string} value
     */

  }, {
    key: "setCachedCatalogId",
    value: function setCachedCatalogId(id) {
      this.cachedCatalogId = id;
    }
    /**
     *
     * @param {string} value
     */

  }, {
    key: "checkIsPEPGateway",
    value: function checkIsPEPGateway(domain) {
      var isPEPDomain = domain.includes('pepgateway');
      this.isPEPGateway = isPEPDomain;
      return isPEPDomain;
    }
    /**
     * @returns {string}
     */

  }, {
    key: "getLanguageCode",
    value: function getLanguageCode() {
      return this.languageCode;
    }
    /**
     * @returns {Promise.<PIMToken|Error>}
     */

  }, {
    key: "getToken",
    value: function getToken(service, forceTokenFromServer) {
      return _PIMTokenService["default"].instance.getTokenForService(service, forceTokenFromServer);
    }
  }, {
    key: "getCulture",
    value: function getCulture(service) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.getToken(service).then(function (token) {
          if (token.culture) {
            resolve(token.culture);
          } else {
            _PIMTokenService["default"].instance.getCulture().then(function (culture) {
              resolve(culture);
            })["catch"](function (reason) {
              reject(reason);
            });
          }
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
  }, {
    key: "getCatalogID",
    value: function getCatalogID(service) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.getToken(service).then(function (token) {
          if (token.catalogId || _this2.getCachedCatalogId()) {
            var newCatalogId = token.catalogId || _this2.getCachedCatalogId();

            _this2.setCachedCatalogId(newCatalogId);

            token.catalogId = newCatalogId;
            resolve(token);
          } else {
            _PIMTokenService["default"].instance.getCatalogID(service).then(function (catalogId) {
              token.catalogId = catalogId;

              _this2.setCachedCatalogId(catalogId);

              resolve(token);
            })["catch"](function (reason) {
              reject(reason);
            });
          }
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
  }, {
    key: "getCatalogStatus",
    value: function getCatalogStatus(service) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.getToken(service).then(function (token) {
          if (token.catalogStatus) {
            resolve(token.catalogStatus);
          } else {
            _PIMTokenService["default"].instance.getCatalogStatus().then(function (catalogStatus) {
              resolve(catalogStatus);
            })["catch"](function (reason) {
              reject(reason);
            });
          }
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     */

  }, {
    key: "flushToken",
    value: function flushToken() {
      _PIMTokenService["default"].instance.flushToken();
    }
    /**
     * @returns {Promise<Device[]|Error>}
     */

  }, {
    key: "getCompatibilityGuideDevices",
    value: function getCompatibilityGuideDevices(params) {
      var _this4 = this;

      var service = new _DeviceContentService["default"]();
      return new Promise(function (resolve, reject) {
        _this4.getToken(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE, '', _this4.checkIsPEPGateway(token.host)).DEVICES);
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<App[]|Error>}
     */

  }, {
    key: "getCompatibilityGuideApps",
    value: function getCompatibilityGuideApps(params) {
      var _this5 = this;

      var service = new _AppContentService["default"]();
      return new Promise(function (resolve, reject) {
        _this5.getToken(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE, token.catalogId, _this5.checkIsPEPGateway(token.host)).APPS);

          if (!_this5.isPEPGateway) {
            service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
              resolve(result);
            })["catch"](function (reason) {
              reject(reason);
            });
          } else {
            resolve([]);
          }
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<Product[]|Error>}
     */

  }, {
    key: "getCompatibilityGuideProducts",
    value: function getCompatibilityGuideProducts(params) {
      var _this6 = this;

      var service = new _ProductContentService["default"]();
      return new Promise(function (resolve, reject) {
        _this6.getToken(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE, token.catalogId, _this6.checkIsPEPGateway(token.host)).PRODUCTS);
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<Accessories[]|Error>}
     */

  }, {
    key: "getCompatibilityGuideAccessories",
    value: function getCompatibilityGuideAccessories(params) {
      var _this7 = this;

      var service = new _AccessoryContentService["default"]();
      return new Promise(function (resolve, reject) {
        _this7.getToken(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE, token.catalogId, _this7.checkIsPEPGateway(token.host)).ACCESSORIES);
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<Resource[]|Error>}
     */

  }, {
    key: "getResourceCenterResources",
    value: function getResourceCenterResources(params, token, productResources) {
      var service, result;
      return regeneratorRuntime.async(function getResourceCenterResources$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              service = new _ResourceContentService["default"]();
              service.languageCode = this.getLanguageCode();

              if (token) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return regeneratorRuntime.awrap(this.getToken(_serviceNames.SERVICE_NAMES.RESOURCE_CENTER));

            case 5:
              token = _context.sent;

            case 6:
              service.endpoint = productResources ? "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.RESOURCE_CENTER).PRODUCT_RESOURCES) : "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.RESOURCE_CENTER).RESOURCES);
              _context.next = 9;
              return regeneratorRuntime.awrap(service.loadWithParamsAndToken(params, token.tokenValue));

            case 9:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
    /**
     * @returns {Promise<Filter[]|Error>}
     */

  }, {
    key: "getResourceCenterFilters",
    value: function getResourceCenterFilters(params) {
      var _this8 = this;

      var service = new _FilterContentService["default"]();
      service.languageCode = this.getLanguageCode();
      return new Promise(function (resolve, reject) {
        _this8.getToken(_serviceNames.SERVICE_NAMES.RESOURCE_CENTER).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.RESOURCE_CENTER).FILTERS);
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<fetchPEPOnlyRelatedAccessories|Error}
     */

  }, {
    key: "fetchPEPOnlyRelatedAccessories",
    value: function fetchPEPOnlyRelatedAccessories(params, token) {
      var service = new _GeneralService["default"]();
      service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).RELATED_ACCESSORIES);
      var productId = location.search.split('productId=')[1] ? location.search.split('productId=')[1] : '';
      params.productId = productId;
      return new Promise(function (resolve, reject) {
        service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
          resolve(result);
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<fetchPEPProductDetails|Error>}
     */

  }, {
    key: "fetchPEPOnlyProductDetails",
    value: function fetchPEPOnlyProductDetails(params, token) {
      var service = new _GeneralService["default"]();
      service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).PRODUCT_DETAILS);
      var productId = location.search.split('productId=')[1] ? location.search.split('productId=')[1] : '';
      params.ProductIds = productId;
      return new Promise(function (resolve, reject) {
        service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
          resolve(result);
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<PEPProductDetailsResponse|Error>}
     */

  }, {
    key: "getPEPProductDetails",
    value: function getPEPProductDetails(params) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        _this9.getToken(_serviceNames.SERVICE_NAMES.PEP).then(function (token) {
          var service = new _ProductDetailsService["default"]();
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).PRODUCT_DETAILS);

          _this9.getCatalogID(_serviceNames.SERVICE_NAMES.PEP).then(function (catalogResponse) {
            params.CatalogId = catalogResponse.catalogId || catalogResponse;

            _this9.getCulture(_serviceNames.SERVICE_NAMES.PEP).then(function (culture) {
              params.Culture = culture;

              _this9.getCatalogStatus(_serviceNames.SERVICE_NAMES.PEP).then(function (catalogStatus) {
                params.CatalogStatus = catalogStatus;
                service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
                  resolve(result);
                })["catch"](function (reason) {
                  reject(reason);
                });
              })["catch"](function (reason) {
                reject(reason);
              });
            })["catch"](function (reason) {
              reject(reason);
            });
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
      * @returns {Promise<fetchPEPOnlyBrowseHearingAids|Error}
      */

  }, {
    key: "fetchPEPOnlyBrowseHearingAids",
    value: function fetchPEPOnlyBrowseHearingAids(params, token) {
      var service = new _GeneralService["default"]();
      service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).BROWSE_HEARING_AIDS);
      return new Promise(function (resolve, reject) {
        service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
          resolve(result);
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
      * @returns {Promise<fetchPEPOnlyBrowseHearingAids|Error}
      */

  }, {
    key: "fetchPEPOnlyBrowseMarketingMaterials",
    value: function fetchPEPOnlyBrowseMarketingMaterials(params, token) {
      var service = new _GeneralService["default"]();
      service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).BROWSE_MARKETING_MATERIALS);
      return new Promise(function (resolve, reject) {
        service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
          resolve(result);
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<PEPRelatedAccessoriesResponse|Error}
     */

  }, {
    key: "getPEPRelatedAccessories",
    value: function getPEPRelatedAccessories(params) {
      var _this10 = this;

      var service = new _RelatedAccessoriesService["default"]();
      return new Promise(function (resolve, reject) {
        _this10.getToken(_serviceNames.SERVICE_NAMES.PEP).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).RELATED_ACCESSORIES);

          _this10.getCatalogID(_serviceNames.SERVICE_NAMES.PEP).then(function (catalogId) {
            params.CatalogId = parseInt(catalogId, 10);

            _this10.getCulture(_serviceNames.SERVICE_NAMES.PEP).then(function (culture) {
              params.Culture = culture;

              _this10.getCatalogStatus(_serviceNames.SERVICE_NAMES.PEP).then(function (catalogStatus) {
                params.CatalogStatus = catalogStatus;
                service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
                  resolve(result);
                })["catch"](function (reason) {
                  reject(reason);
                });
              })["catch"](function (reason) {
                reject(reason);
              });
            })["catch"](function (reason) {
              reject(reason);
            });
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
      * @returns {Promise<fetchPEPOnlyBrowseHearingAids|Error}
      */

  }, {
    key: "fetchPEPOnlyAccessories",
    value: function fetchPEPOnlyAccessories(params, token) {
      var service = new _GeneralService["default"]();
      service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).BROWSE_ACCESSORIES);
      return new Promise(function (resolve, reject) {
        service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
          resolve(result);
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<PEPBrowseAccessoriesResponse|Error>}
     */

  }, {
    key: "getPEPBrowseAccessories",
    value: function getPEPBrowseAccessories(params) {
      var _this11 = this;

      var service = new _BrowseAccessoriesService["default"]();
      return new Promise(function (resolve, reject) {
        _this11.getToken(_serviceNames.SERVICE_NAMES.PEP).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).BROWSE_ACCESSORIES);
          params.CatalogId = token.catalogId;
          params.Culture = token.culture;
          params.CatalogStatus = token.catalogStatus;
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
    /**
     * @returns {Promise<PEPBrowseHearingAidsResponse|Error>}
     */

  }, {
    key: "getPEPBrowseHearingAids",
    value: function getPEPBrowseHearingAids(params) {
      var _this12 = this;

      var service = new _BrowseHearingAidsService["default"]();
      return new Promise(function (resolve, reject) {
        _this12.getToken(_serviceNames.SERVICE_NAMES.PEP).then(function (token) {
          service.endpoint = "".concat(token.host).concat((0, _serviceEndpoints["default"])(_serviceNames.SERVICE_NAMES.PEP).BROWSE_HEARING_AIDS);
          params.CatalogId = token.catalogId;
          params.Culture = token.culture;
          service.loadWithParamsAndToken(params, token.tokenValue).then(function (result) {
            resolve(result);
          })["catch"](function (reason) {
            reject(reason);
          });
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
  }]);

  return PIM;
}();

var _default = PIM;
/**
 * @typedef {import('../models/pep/PEP').PEPBrowseAccessoriesResponse} PEPBrowseAccessoriesResponse
 */

/**
 * @typedef {import('../models/pep/PEP').PEPBrowseHearingAidsResponse} PEPBrowseHearingAidsResponse
 */

/**
 * @typedef {import('../models/pep/PEP').PEPProductDetailsResponse} PEPProductDetailsResponse
 */

/**
 * @typedef {import('../models/pep/PEP').PEPRelatedAccessoriesResponse} PEPRelatedAccessoriesResponse
 */

exports["default"] = _default;